export const IconCheckSuccessSubmitConfirm: {
  name: 'icon_check_success_submit_confirm-f033d8d9da00'
} = {
  name: 'icon_check_success_submit_confirm-f033d8d9da00'
}
